/**
 * Boli Live - Bottom Navigation Component
 *
 * eBay-style bottom navigation.
 */

import { NavLink, useLocation } from 'react-router-dom';
import { Home, Heart, Tag, MessageSquare, User } from 'lucide-react';
import { cn } from '../lib/utils';
import { useAuthStore } from '../lib/stores/auth-store';

const navItems = [
  { path: '/', icon: Home, label: 'Home' },
  { path: '/saved', icon: Heart, label: 'Saved', requiresAuth: true },
  { path: '/seller', icon: Tag, label: 'Selling', requiresAuth: true },
  { path: '/inbox', icon: MessageSquare, label: 'Inbox', requiresAuth: true },
  { path: '/profile', icon: User, label: 'My Boli' },
];

export function BottomNav() {
  const location = useLocation();
  const { isAuthenticated } = useAuthStore();

  // Hide on auction room (full-screen experience)
  if (location.pathname.startsWith('/auction/')) {
    return null;
  }

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-background border-t border-border safe-bottom pb-1">
      <div className="flex items-center justify-around h-14 mx-auto px-2">
        {navItems.map(({ path, icon: Icon, label, requiresAuth }) => {
          // In a real app we might show these but prompt login. 
          // For now, let's show them but maybe redirect if clicked? 
          // Or just hide them as requested. keeping logic same for now.
          if (requiresAuth && !isAuthenticated) {
            // Optional: You could show them and redirect to login
            // return null; 
          }

          const isActive =
            path === '/' ? location.pathname === '/' : location.pathname.startsWith(path);

          return (
            <NavLink
              key={path}
              to={path}
              className={cn(
                "flex flex-col items-center justify-center w-full h-full gap-0.5 active:scale-95 transition-transform",
                isActive ? "text-primary" : "text-muted-foreground hover:text-foreground"
              )}
            >
              <Icon
                className={cn(
                  "w-6 h-6",
                  isActive && "fill-current" // Optional: fill icon if active style preferred
                )}
                strokeWidth={isActive ? 2.5 : 2}
              />
              <span className="text-[10px] font-medium">{label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
